import { useApi } from '@/shared/api/http';
import type {
  IGetPracticeParams,
  IPracticePayload,
} from '@/entities/practice/model/types/practice';

export const usePracticeService = () => {
  const api = useApi();

  const getPractice = async (params: IGetPracticeParams) => {
    return await api.get('legal-practice/', { params: { ...params } });
  };

  const createPractice = async (dataReq: IPracticePayload) => {
    return await api.post('legal-practice', dataReq);
  };

  const updatePractice = async (practiceId: number, dataReq: IPracticePayload) => {
    return await api.patch(`legal-practice/${practiceId}`, dataReq);
  };

  const deletePractice = async (practiceId: number) => {
    return await api.delete(`legal-practice/${practiceId}`);
  };

  return {
    getPractice,
    createPractice,
    updatePractice,
    deletePractice,
  };
};
